// extracted by mini-css-extract-plugin
export default {"main":"inquiries_main__4eGK4"};